import { render } from "./PresentationSlideTwo.vue?vue&type=template&id=4d61cd28&scoped=true"
import script from "./PresentationSlideTwo.vue?vue&type=script&lang=js"
export * from "./PresentationSlideTwo.vue?vue&type=script&lang=js"

import "./PresentationSlideTwo.vue?vue&type=style&index=0&id=4d61cd28&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d61cd28"]])

export default __exports__